import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const LINKS = [
  { label: "The Audit", href: "#audit" },
  { label: "Advisory", href: "#advisory" },
  { label: "Transformation", href: "#transformation" },
];

export default function AdvisoryNav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="advisory-nav"
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "bg-[hsl(40_33%_98%/0.78)] backdrop-blur-xl border-b border-border"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="container-luxe flex h-[72px] items-center justify-between">
        <Link to="/" data-testid="advisory-nav-logo" className="flex items-baseline gap-2">
          <span className="serif text-xl sm:text-2xl tracking-tight text-[hsl(var(--foreground))]">Beam</span>
          <span className="serif text-xl sm:text-2xl tracking-tight gold-shimmer">Concierge</span>
        </Link>

        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`advisory-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="link-underline text-sm text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#audit"
            data-testid="advisory-nav-cta"
            className="group inline-flex items-center gap-2 bg-secondary px-5 py-2.5 text-sm text-secondary-foreground hover:bg-[var(--gold)] transition-colors duration-400 whitespace-nowrap"
          >
            Take the Audit
            <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>

        <a
          href="#audit"
          data-testid="advisory-nav-cta-mobile"
          className="lg:hidden inline-flex items-center gap-2 bg-secondary px-4 py-2 text-xs text-secondary-foreground"
        >
          Take the Audit
        </a>
      </nav>
    </motion.header>
  );
}
